import moment from "moment";
export default {
  user_info: (localStorage.getItem("user_info") && JSON.parse(localStorage.getItem("user_info"))) || "",
  exclude: null,
  lang: localStorage.getItem("lang") || "zh",
  locale: JSON.parse(localStorage.getItem("locale")) || "",
  panes: JSON.parse(localStorage.getItem("panes")) || ["dashboard"],
  pagination_setting: {
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "30", "40"]
  },
  show_time_setting: {
    hideDisabledOptions: true,
    defaultValue: [moment("00:00:00", "HH:mm:ss"), moment("11:59:59", "HH:mm:ss")]
  },
  menu_list: [
    // {
    //   view: "dashboard",
    //   icon: "dashboard",
    //   children: []
    // },
    {
      view: "orderManage",
      icon: "unordered-list",
      children: [
        {
          view: "orderList"
        }
      ]
    },
    {
      view: "messageManage",
      icon: "message",
      children: [
        {
          view: "question"
        }
      ]
    }
  ]
};
